import type * as A from '@/api';
import type { SupportedDownloadRecordTypes } from '@/services/download';
import { graphql } from '@/utils/graphql';

export async function noLint_waitForUnloadToComplete(
  dataType: SupportedDownloadRecordTypes,
  dataCloudResourceId: string,
  executionId: string,
  checkUnloadProps: string,
): Promise<void> {
  const MAX_TIME = Date.now() + 60 * 60 * 1000; // 1 hour max
  let i = 0;

  while (Date.now() < MAX_TIME) {
    const waitTime = 1000 * Math.min(30, i);
    await new Promise((resolve) => setTimeout(resolve, waitTime));
    i += 1;

    const query: A.CheckUnloadQueryInput = {
      dataType,
      dataCloudResourceId,
      executionId,
      checkUnloadProps,
    };

    const { isStillRunning } = await graphql('beemAgentCheckUnload', { query });
    if (!isStillRunning) return;
  }

  throw new Error('Unload exceeded the maximum wait time of 60 minutes.');
}
